import { render, staticRenderFns } from "./donor-card-tiers.vue?vue&type=template&id=1bbf413a&"
import script from "./donor-card-tiers.vue?vue&type=script&lang=js&"
export * from "./donor-card-tiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports